<template>
  <MetricCard
    apiEndpoint="/linkedin-pages/followers"
    metricName="FOLLOWERS"
    :formatData="formatData"
    srcName="LinkedIn Pages"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import MetricCard from '@/components/MetricCard.vue';
const formatData = (data) => formatNumber(data.data);
</script>
